import { render, staticRenderFns } from "./allActiveGradeSubDetail.vue?vue&type=template&id=6ea74d80&scoped=true&"
import script from "./allActiveGradeSubDetail.vue?vue&type=script&lang=js&"
export * from "./allActiveGradeSubDetail.vue?vue&type=script&lang=js&"
import style0 from "./allActiveGradeSubDetail.vue?vue&type=style&index=0&id=6ea74d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea74d80",
  null
  
)

export default component.exports